/**
 * Merged composed-template catalog entries (plan §6.3). Per-industry files
 * are owned by their P4b copywriting task; this merge file and the file list
 * are fixed — do not add entries here.
 */
import type { TemplateEntryDraft } from '../template-catalog';
import { COMPOSED_BEAUTY_TEMPLATES } from './beauty';
import { COMPOSED_CORPORATE_TEMPLATES } from './corporate';
import { COMPOSED_LAW_TEMPLATES } from './law';
import { COMPOSED_MEDICAL_TEMPLATES } from './medical';
import { COMPOSED_RESTAURANT_TEMPLATES } from './restaurant';
import { COMPOSED_RETAIL_TEMPLATES } from './retail';

export const COMPOSED_TEMPLATE_ENTRIES: readonly TemplateEntryDraft[] = [
  ...COMPOSED_BEAUTY_TEMPLATES,
  ...COMPOSED_RESTAURANT_TEMPLATES,
  ...COMPOSED_LAW_TEMPLATES,
  ...COMPOSED_CORPORATE_TEMPLATES,
  ...COMPOSED_RETAIL_TEMPLATES,
  ...COMPOSED_MEDICAL_TEMPLATES,
];
